import ApiCall from "../constants/Api";
import SiteConfig from "../constants/SiteConfig";
import { helpAxios } from "../helpers/helpAxios";
import { errorHandler } from "../components/ErrorHandler";

export const useSpecialFunctions = () => {
  //LoginUser function
  const loginUser = async (request) => {
    let response;
    try {
      response = await helpAxios("", ApiCall.LOGIN_USER, {
        ...request,
      });

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  //LogoutUser function
  const logoutUser = async (LogonSessionID) => {
    let response;
    try {
      response = await helpAxios("", ApiCall.LOGOUT_USER, {}, LogonSessionID);

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  // Get the time from a dateTime and format it
  const getTimeInfo = (time) => {
    var postTime = new Date(time);
    return (
      ("0" + postTime.getHours()).slice(-2) +
      ":" +
      ("0" + postTime.getMinutes()).slice(-2) +
      ":" +
      ("0" + postTime.getSeconds()).slice(-2)
    );
  };

  // Get the time from a dateTime and format it
  const getHoursMinutes = (time) => {
    var postTime = new Date(time);
    return (
      ("0" + postTime.getHours()).slice(-2) +
      ":" +
      ("0" + postTime.getMinutes()).slice(-2)
    );
  };

  // Get the date from a date and format it
  const getDateInfo = (date) => {
    var postTime = new Date(date);
    return (
      ("0" + (postTime.getMonth() + 1)).slice(-2) +
      "/" +
      ("0" + postTime.getDate()).slice(-2) +
      "/" +
      postTime.getFullYear()
    );
  };

  return {
    loginUser,
    logoutUser,
    getTimeInfo,
    getHoursMinutes,
    getDateInfo,
  };
};
